var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPasswordHide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.077,
    height: 17.685,
    viewBox: "0 0 25.077 17.685",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1622 -477.157)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1622 372.338)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 106.662)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.984,113.679c-.2-.287-4.943-7.017-12.446-7.017-6.438,0-12.174,6.691-12.415,6.977a.524.524,0,0,0,0,.675c.241.285,5.978,6.977,12.415,6.977s12.174-6.691,12.415-6.977A.523.523,0,0,0,24.984,113.679Zm-12.446,6.566c-5.161,0-10.068-4.921-11.314-6.269,1.244-1.349,6.146-6.269,11.314-6.269,6.038,0,10.3,4.914,11.341,6.241C22.678,115.253,17.743,120.246,12.539,120.246Z",
    transform: "translate(0 -106.662)",
    fill: "#8398bc"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.359 109.797)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174.842,170.662a4.18,4.18,0,1,0,4.18,4.18A4.184,4.184,0,0,0,174.842,170.662Zm0,7.314a3.135,3.135,0,1,1,3.135-3.135A3.139,3.139,0,0,1,174.842,177.976Z",
    transform: "translate(-170.662 -170.662)",
    fill: "#8398bc"
  })))), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y2: 17,
    transform: "translate(1627.5 477.5)",
    fill: "none",
    stroke: "#8398bc",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordHide);
export default __webpack_public_path__ + "static/media/password-hide.541d96c3c77bb9b727e7929f17ff5235.svg";
export { ForwardRef as ReactComponent };